module.exports = __webpack_public_path__ + "img/about-1-min.d966235b.png";